var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeadress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.2 92.5",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 47v-1.7a14.52 14.52 0 011.72-2.83Q21.49 22.6 41.36 2.84A10 10 0 0145 .57c3.85-1.37 7.21-.2 10.05 2.64L93.37 41.5a9.81 9.81 0 012.83 4v1.69c-1.3 3.31-2.43 4.07-6.08 4.07H83.5v31.35a9.45 9.45 0 01-9.82 9.82L46 92.5H22.43a9.22 9.22 0 01-5.87-1.87 9.32 9.32 0 01-3.65-7.85V51.25H5.45A5.1 5.1 0 011 49.08 13.36 13.36 0 010 47zm7.46-2.07a3.71 3.71 0 00.52.2h7.23c2.62 0 3.76 1.15 3.76 3.79v33.72c0 2.53 1.22 3.77 3.72 3.77h10.24c.3 0 .6 0 1-.06V59.9v-.94a3.06 3.06 0 013.21-3.17h22a3 3 0 013.14 2.05 6.07 6.07 0 01.21 1.76v25.83c0 .77.21 1 1 1h9.86c2.72 0 3.89-1.17 3.89-3.87V48.65a3.15 3.15 0 013.48-3.49h7c.26 0 .52 0 .77-.06l.13-.24a7.41 7.41 0 01-.82-.63L50.81 7.28c-2-2-3.43-2-5.43 0L8.45 44.21a9.07 9.07 0 01-.99.71zm32.6 16.94v24.41H56.3V61.86z",
    fill: "#878789",
    "data-name": "Capa 1"
  }))));
}

export default SvgHomeadress;